// extracted by mini-css-extract-plugin
export default {"container":"LLMIndicator_container__dkixz","icon":"LLMIndicator_icon__8Eu52","truncate":"LLMIndicator_truncate__hARlK"};